import { createContext } from 'react';
const MailContext = createContext();
export default MailContext;
